import {Typography, Box, Grid, Checkbox, TextField, FormControlLabel} from '@mui/material'

import {useTranslation} from '../../../../../../hooks/useTranslation'
import {useExtraDistance} from '../../hooks/orderCancellationSettings'

import {useStyles} from './ExtraDistance.styles'

export const ExtraDistance = () => {
  const {t} = useTranslation()
  const {classes} = useStyles()

  const {isEnabled, toggleExtraDistance, threshold, extraLeadTime} = useExtraDistance()

  return (
    <Box className={classes.container}>
      <Typography className={classes.title}>
        {t(
          'configurations.hconnect.orderManagement.configurationDetails.orderCancellation.extraDistance.title'
        )}
      </Typography>
      <Typography className={classes.description}>
        {t(
          'configurations.hconnect.orderManagement.configurationDetails.orderCancellation.extraDistance.description'
        )}
      </Typography>
      <Grid container className={classes.gridContainer} spacing={2}>
        <Grid item lg={1} md={2} sm={12} xs={12} className={classes.gridItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isEnabled}
                onChange={(e) => toggleExtraDistance(e.target.checked)}
                color="primary"
                data-test-id={'order-cancellation-extra-distance-isEnabled'}
              />
            }
            label={t(
              'configurations.hconnect.orderManagement.configurationDetails.orderCancellation.extraDistance.enabled'
            )}
          />
        </Grid>

        {isEnabled && (
          <>
            <Grid item lg={2} md={4} sm={12} xs={12} className={classes.gridItem}>
              <TextField
                label={t(
                  'configurations.hconnect.orderManagement.configurationDetails.orderCancellation.extraDistance.threshold'
                )}
                type="number"
                {...threshold}
                className={classes.select}
                data-test-id={'order-cancellation-extra-distance-threshold'}
              />
            </Grid>
            <Grid item lg={2} md={4} sm={12} xs={12} className={classes.gridItem}>
              <TextField
                label={t(
                  'configurations.hconnect.orderManagement.configurationDetails.orderCancellation.extraDistance.extraLeadTime'
                )}
                type="number"
                {...extraLeadTime}
                className={classes.select}
                data-test-id={'order-cancellation-extra-distance-extraLeadTime'}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  )
}
